import React from "react";
import addToCard from "../../../../cookieStorage/addToCard";
import {useNavigate} from "react-router-dom";


function ProductElementPopular(props) {

    const navigate = useNavigate();
    /*const product = {
        id: props.productID,
        name: props.name,
        image: props.image,
        description: props.description,
        price: props.price,
        quantity: 1

    };*/

    return (
        <div id={"product-" + props.id}
             className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden">
            <div className="h-80 overflow-hidden">
                <img
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    src={props.image}
                    alt={props.name}/>
            </div>
            <div className="p-6">
                <h3 className="text-xl font-serif font-semibold mb-2">{props.name}</h3>
                <p className="text-gray-600 mb-4">{props.description}</p>
                <div className="flex items-center justify-between">
                    <span className="text-2xl font-bold text-brand-green">€{props.price}</span>
                    <button onClick={()=>{navigate(`/products/productpage/${props.productID}`)}}
                        className="bg-custom-green hover:bg-light-green text-white px-6 py-2 rounded-lg font-medium transition-colors duration-300">
                        Add to Cart
                    </button>
                </div>
            </div>
        </div>

    )
}

export default ProductElementPopular;